import {FC, ReactElement} from "react";
import Button from "./Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import {SlideTransition} from "./Dialog.tsx";

type FeedbackDialogProps = {
    id: string
    open: boolean
    title?: string
    contents: string | ReactElement
    onConfirm?: () => void
    onClose: () => void
}

const FeedbackDialog: FC<FeedbackDialogProps> = ({id, open, title, contents, onConfirm, onClose}) => (
    <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby={`${id}-title`}
        aria-describedby={`${id}-description`}
        slots={{
            transition: SlideTransition,
        }}
        keepMounted
        sx={{zIndex: 1400}}
    >
        <DialogTitle id={`${id}-title`}>
            {title ?? (onConfirm ? "Weet u het zeker?" : "Informatie")}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id={`${id}-contents`}>
                {contents}
            </DialogContentText>
        </DialogContent>
        {onConfirm ? ( // confirmation dialog
            <DialogActions>
                <Button onClick={onClose}>Nee</Button>
                <Button onClick={onConfirm} autoFocus color="error">Ja</Button>
            </DialogActions>
        ) : ( // info dialog
            <DialogActions>
                <Button onClick={onClose} autoFocus>Sluiten</Button>
            </DialogActions>
        )}
    </Dialog>
)


export default FeedbackDialog
